import './Card.css'

import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import FadeIn from './FadeIn'
import { Flex } from './Flex'
import { Text } from './Text'

const transition = { default: { duration: 0.4 } }
const CardContainer = ({ children, ...props }) => (
  <motion.div
    {...props}
    variants={{
      open: { height: 'auto', opacity: 1, marginTop: 10, transition },
      closed: { height: 0, opacity: 0, marginTop: 0, transition }
    }}
  >
    {children}
  </motion.div>
)

const ChevronContainer = ({ children, ...props }) => (
  <motion.div
    {...props}
    variants={{
      open: { rotate: 0, transition },
      closed: { rotate: 180, transition }
    }}
  >
    {children}
  </motion.div>
)

export const Card = ({
  fadeIn,
  collapsable,
  title,
  titleCollapsed,
  titleStyle,
  collapsed,
  children,
  style,
  customHeader,
  onExpand,
  onClick = () => {}
}) => {
  const [state, setState] = useState('closed')
  const isCollapsed = state === 'closed'

  const toggleCollapse = (newState) => {
    const applyNewState = newState || (isCollapsed ? 'open' : 'closed')
    setState(applyNewState)
    applyNewState === 'open' && onExpand && onExpand()
  }

  useEffect(() => {
    collapsable && setState(collapsed ? 'closed' : 'open')
  }, [collapsable, collapsed])

  const cardClassName = [
    'card',
    'nora-card',
    collapsable && 'nora-card--collapsable',
    collapsable && isCollapsed && !customHeader && 'nora-card--collapsed'
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <FadeIn
      enabled={fadeIn}
      style={{ ...(style ? { width: style.width, height: style.height } : {}) }}
    >
      <div
        className={cardClassName}
        style={style}
        {...(isCollapsed && !customHeader ? { onClick: () => toggleCollapse('open') } : {})}
      >
        {!customHeader && !title ? null : (
          <Flex row jb fw>
            <Flex row js>
              {title ? (
                <Text
                  title
                  bold
                  value={
                    titleCollapsed
                      ? isCollapsed
                        ? titleCollapsed
                        : title?.toUpperCase()
                      : title?.toUpperCase()
                  }
                  className="nora-card__title"
                  style={titleStyle}
                  size={20}
                />
              ) : null}
            </Flex>
            {customHeader}
            <ChevronContainer
              initial="closed"
              animate={state}
              className={
                !collapsable
                  ? 'nora-card__chevron nora-card__chevron--hidden'
                  : 'nora-card__chevron'
              }
              onClick={() => (customHeader || !isCollapsed) && toggleCollapse()}
            >
              <i className="pi pi-chevron-down nora-card__chevron-icon" />
            </ChevronContainer>
          </Flex>
        )}
        {!collapsable ? (
          <div onClick={onClick}>{children}</div>
        ) : (
          <CardContainer initial="closed" className="nora-card__body--collapsable" animate={state}>
            {children}
          </CardContainer>
        )}
      </div>
    </FadeIn>
  )
}
